import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';


const emailGroup = lazy(() => import('../../container/email-group'));

const EmailGroup = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/emailGroup`} component={emailGroup}/>
        </Switch>
    );
};

export default EmailGroup;
